import { DAOButton } from "components/button";
import { CustomerInterface, Rarity } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "reducer/store";
import { bulkSetUserInfo } from "reducer/user.slice";
import { api, ui, utils } from "services";

export default function MAGVault() {
    const { t } = useTranslation();
    const [vaultConfig, setConfig] = useState([]);
    const [total, setTotal] = useState(0);
    const [trigger, setTrigger] = useState(false);
    const user = useSelector((state: RootState) => state.user);


    const getVault = async () => {
        let rs = await api.getVault();
        if (rs?.length) {
            let totalPool = rs.reduce((prev: number, cur: any) => {
                return prev + cur.totalPool
            }, 0)
            setTotal(totalPool)
            setConfig(rs)
        }
    }

    useEffect(() => {
        getVault()
    }, [trigger])

    return (
        <div className="w-full relative">
            <div className="text-center mx-auto relative max-w-[600px] w-full translate-y-[-10px]"
                style={{
                    background: `url("/assets/images/card/vault-card.png")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    height: "100%",
                    position: "relative",
                    backgroundPosition: "bottom center",
                }}
            >
                <div className="text-white flex flex-col gap-1 mx-auto text-center justify-center self-center py-6 pb-8">
                    <div className="text-xl">MAG Shared Revenue:</div>
                    <div className="flex gap-2 mx-auto text-center justify-center">
                        <img src="/assets/images/items/mag-icon-large.webp" className="h-8 translate-y-[4px]" alt="mag" />
                        <div className="text-3xl font-cookie-run text-gradient">{utils.convertToInternationalCurrencySystem(Number(total), 2)} MAG</div>
                    </div>
                </div>
            </div>
            <div className="text-white flex gap-1 mx-auto text-center justify-center self-center pt-2">
                <div className="flex gap-1 mx-auto text-center justify-center">
                    <div className="text-xl self-center">Your Staked MAG:</div>
                    <div className="text-xl font-cookie-run text-gradient self-center">{utils.convertToInternationalCurrencySystem(user?.[CustomerInterface.staked_mag] ?? 0)} MAG</div>
                    <img src="/assets/images/items/mag-icon-large.webp" className="h-7" alt="mag" />
                </div>
            </div>
            <div className="flex flex-wrap gap-4 gap-y-10 justify-center w-full py-6">
                {[Rarity.Common, Rarity.Uncommon, Rarity.Rare, Rarity.Epic, Rarity.Legendary].map((rarity) => {
                    return (
                        <RarityCard vaultConfig={vaultConfig} rarity={rarity} trigger={trigger} setTrigger={setTrigger} />
                    )
                })}
            </div>
        </div >
    )
}


const RarityCard = ({ vaultConfig, rarity, trigger, setTrigger }: { vaultConfig: any, rarity: Rarity, trigger: boolean, setTrigger: any }) => {
    const nav = useNavigate();
    const dispatch = useDispatch();
    const user: any = useSelector((state: RootState) => state.user);
    const [loadingRestake, setLoadingRestake] = useState(false);
    const { t } = useTranslation();

    let config = vaultConfig[rarity]
    return (
        <div className="relative flex flex-col gap-y-4">
            <div className="relative font-cookie-run rounded-lg w-[204px] 2xl:w-[240px]" key={`card-${rarity}`}
                style={{
                    background: `url("/assets/images/card/card-${rarity}.webp")`,
                    backgroundRepeat: "no-repeat",
                    height: "100%",
                    position: "relative",
                    backgroundSize: "cover",
                    backgroundPosition: "top center",
                }}
            >
                <div className="text-white flex flex-col gap-1 mx-auto px-4 py-5">
                    <div className="text-xl text-center font-bold flex gap-2 mx-auto">
                        <img src={`/assets/images/rarity/${Rarity[rarity].toLocaleLowerCase()}.png`} className="w-7 h-7" />
                        <div className="self-center">{Rarity[rarity]}</div>
                    </div>
                    <div className="flex justify-between">
                        <div className="text-sm text-[#939393] mt-4">Total pool</div>
                        <div className="text-sm text-[#939393] mt-4">Total point</div>
                    </div>
                    <div className="flex justify-between">
                        <div className="text-[13px]">{utils.convertToInternationalCurrencySystem(config?.totalPool ?? 0)} MAG</div>
                        <div className="text-[13px] text-right">{utils.convertToInternationalCurrencySystem(config?.totalPoint ?? 0)} <span className="text-sm">Points</span></div>
                    </div>
                    <div className="br my-4"></div>

                    <div className="flex justify-between">
                        <div className="text-sm text-[#939393]">Your point</div>
                        <div className="text-sm text-[#939393]">Expire Pts.<br /> in next hour</div>
                    </div>
                    <div className="flex justify-between">
                        <div className="text-md">{utils.convertToInternationalCurrencySystem(config?.myPoint ?? 0)} <span className="text-sm">Points</span></div>
                        <div className="text-md">{utils.convertToInternationalCurrencySystem(config?.expiredPoint ?? 0)} <span className="text-sm">Points</span></div>
                    </div>

                    <div className="text-sm text-[#939393]">MAG/Hour</div>
                    <div className="text-md">{utils.convertToInternationalCurrencySystem(config?.magPerHour ?? 0)} MAG</div>

                    <div className="br my-4"></div>

                    <div className="text-sm text-[#939393]">My reward</div>
                    <div className="text-md">{utils.convertToInternationalCurrencySystem(config?.reward ?? 0)} MAG</div>
                </div>
                <div className="flex pb-6 gap-4 px-3 w-full mt-3">
                    <DAOButton
                        disabled={!user?.[CustomerInterface.id] || !sessionStorage.getItem('token') || !Number(config?.reward ?? 0)}
                        loading={loadingRestake}
                        color="yellow" theme="yellow" icon="restake-icon.png"
                        onClick={async () => {
                            try {
                                setLoadingRestake(true)
                                const { customerInfo } = await api.restakeMagStake(rarity)
                                dispatch(bulkSetUserInfo(customerInfo));
                                ui.alertSuccess("Restake successful !", "");
                                setTrigger(!trigger);
                            } catch (err: any) {
                                ui.alertFailed("Restake failed !", t(err?.message ?? err));
                            } finally {
                                setLoadingRestake(false)
                            }
                        }}
                        className="text-sm 2xl:text-[14px]"
                    >
                        Restake
                    </DAOButton>
                    <DAOButton
                        color="green" theme="light"
                        onClick={() => {
                            nav(`/exchange-point/${rarity}`)
                        }}
                        className="text-sm 2xl:text-[14px]"
                    >
                        Exchange
                    </DAOButton>
                </div>
            </div>
        </div>
    )
}